import { Spinner } from "react-bootstrap";
import FileUpload from "components/FileUploader/FileUpload";
import AutoCompleteDropdown from "components/autocomplete/AutoCompleteDropdown";
import { displayNotification, generateOptionsFromData } from "helpers";
import { useGetListByMasterIdQuery } from "modules/pvs_activities/redux/service/lists";
import { useCreateExpertToolDocumentsMutation } from "modules/pvs_activities/redux/service/missions";
import React, { useMemo } from "react";
import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import FileField from "../core/FileField";


const AddExpertToolDocumentModal = ({ isShow, uploadModel }) => {
    const [createMissionDocuments, { isLoading }] = useCreateExpertToolDocumentsMutation();

    const [file, setFile] = useState([]);

    const handleSave = async () => {
        const formData = new FormData();
        file.forEach((file, index) => {
            formData.append(`file_name`, file);
        });
        createMissionDocuments(formData).then((response) => {
            if (response.error) {
                displayNotification("error", "An error occured when submitting");
            } else {
                displayNotification("success", "Successfully Submitted Document");
                setFile([]);
                uploadModel();
            }
        });
    };

    return (
        <>
            <Modal show={isShow}>
                <Modal.Header closeButton onClick={() => uploadModel()}>
                    <Modal.Title>Upload Document</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <FileField
                        textfieldProps={{ label: "File" }}
                        autoCompleteProps={{ className: "my-2" }}
                        width={"98%"}
                        files={file}
                        setFiles={setFile}
                    />
                </Modal.Body>

                <Modal.Footer>
                    <div className="col-md-12 d-flex justify-content-center">
                        <Button variant="primary" onClick={handleSave}>
                            {isLoading ? (
                                <>
                                    <Spinner animation="border" size="sm" className="me-3" /> <span>Uploading</span>
                                </>
                            ) : (
                                <span>Upload</span>
                            )}
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default AddExpertToolDocumentModal;
